import { React, useRef, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../Context/LanguageContext';

import ReplyDeleteModal from './ReplyDeleteModal';
import UserProfile from '../../../Component/Normal/UserProfile';

import DefaultLogo from '../../../image/DefaultLogo.png';

const ReplyBox = (props) => {
  const { data, isLast, rendering, commentRef, infoRef, commentId } = props;

  const { t } = useLanguage();

  const [deleteClick, setDeleteClick] = useState(false);

  const TopLevelRef = useRef();
  const RightRef = useRef();

  function scrollToMove() {
    commentRef.current.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
    infoRef.current.setName(data.name);
    infoRef.current.setCommentId(commentId);
  }

  return (
    <TopLevelWrapper ref={TopLevelRef} isLast={isLast}>
      {deleteClick && <ReplyDeleteModal replyId={data.id} rendering={rendering} exitClickFn={() => setDeleteClick(false)}/>}
      <LeftWrapper>
        <LineWrapper>
          <Line/>
        </LineWrapper>
        <ProfileWrapper>
          <UserProfile profile={data.profile} defaultProfile={DefaultLogo} />
        </ProfileWrapper>
      </LeftWrapper>
      <MemberInfoWrapper ref={RightRef}>
        <NameWrapper>
          <Name>{data.name}</Name>
          <Info>{data.memberId === -1 ? t('noticePage.coach') : t('noticePage.member')}</Info>
          {data.memberId === -1 && <State>{t('noticePage.author')}</State>}
        </NameWrapper>
        <TextWrapper>
          <Text>{data.text}</Text>
        </TextWrapper>
        <BottomWrapper>
          <Date>{moment(data.createdDate).format(t('noticePage.dateTimeFormat'))}</Date>
          <ReplyButton onClick={scrollToMove}>{t('noticePage.comment.reply')}</ReplyButton>
          {data.memberId === -1 && <ReplyDeleteButton onClick={() => setDeleteClick(true)}>{t('noticePage.comment.deleteReply')}</ReplyDeleteButton>}
        </BottomWrapper>
      </MemberInfoWrapper>
    </TopLevelWrapper>
  )
}

export default ReplyBox;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 0 0 16px 0;

  gap: 10px;
  margin-left: 11px;
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 44px;
  height: 16px;

  margin-left: -2px;
`;

const LineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  height: 100%;
`;


const Line = styled.div`
  display: flex;

  width: 18px;
  height: 28px;

  border-radius: 0 0 0 8px;
`;

const MemberInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
  
  margin-top: 12px;
`;

const ProfileWrapper = styled.div`
  width: 24px;
  height: 24px;

  border-radius: 4px;

  margin-top: 28px;

  overflow: hidden;
`;

const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const Name = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Info = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.line};

  margin: 0 0 0 0;
`;

const State = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: ${props => props.theme.primary};

  margin: 0 0 0 0;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 12px;
`;

const Text = styled.pre`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const BottomWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 16px;
  margin-top: 4px;
`;

const Date = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.line};

  margin: 0 0 0 0;
`;

const ReplyButton = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;

  &:hover {
    cursor: pointer;
  }
`;

const ReplyDeleteButton = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.pointRed};

  margin: 0 0 0 0;

  &:hover {
    cursor: pointer;
  }
`;